const state = {
  xmcbhsParams: {
    bmbh: "",
    xmbh: "",
    time: [],
  },
};
const mutations = {
  saveXmcbhsParams(state, payload) {
    state.xmcbhsParams = payload;
  },
};
const actions = {
  setXmcbhsParams(context, payload) {
    context.commit("saveXmcbhsParams", payload);
  },
};
export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
